import { supabase } from '@/lib/supabase'

export type SlackAppConfig = { client_id: string | null; has_secret: boolean }
export type SlackWorkspace = { id: number; team_id: string; team_name: string; enabled: boolean; installed_at: string | null }
export type SlackChannel = { id: string; name: string; is_private?: boolean; is_member?: boolean; selected?: boolean }

const SB_URL = import.meta.env.VITE_SUPABASE_URL as string
const ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string

export async function getSlackAppConfig(): Promise<SlackAppConfig> {
  const { data, error } = await supabase.rpc('get_slack_app_config')
  if (error) throw error
  const row = Array.isArray(data) ? data[0] : data
  return { client_id: row?.client_id ?? null, has_secret: !!row?.has_secret }
}

export async function setSlackAppConfig(client_id: string, client_secret: string, signing_secret: string): Promise<void> {
  const { error } = await supabase.rpc('set_slack_app_config', { p_client_id: client_id, p_client_secret: client_secret, p_signing_secret: signing_secret })
  if (error) throw error
}

export async function listSlackWorkspaces(): Promise<SlackWorkspace[]> {
  const { data, error } = await supabase.rpc('list_slack_workspaces')
  if (error) throw error
  return (data as SlackWorkspace[]) || []
}

export async function listWorkspaceChannels(workspace_id: number): Promise<SlackChannel[]> {
  const resp = await fetch(`${SB_URL}/functions/v1/slack-list-channels`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${ANON}`,
      'apikey': ANON,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ workspace_id })
  })
  if (!resp.ok) throw new Error(await resp.text())
  const json = await resp.json()
  return (json?.channels as SlackChannel[]) || []
}

export async function saveSelectedChannels(workspace_id: number, channels: Array<{ id: string; name: string; notify: boolean }>): Promise<void> {
  const { error } = await supabase.rpc('save_selected_channels', { p_workspace_id: workspace_id, p_channels: channels as any })
  if (error) throw error
}

export async function setWorkspaceEnabled(workspace_id: number, enabled: boolean): Promise<void> {
  const { error } = await supabase.rpc('set_slack_workspace_enabled', { p_workspace_id: workspace_id, p_enabled: enabled })
  if (error) throw error
}

export function buildSlackOAuthUrl(client_id: string): string {
  const redirect = `${SB_URL}/functions/v1/slack-oauth-callback`
  const scopes = encodeURIComponent('chat:write,channels:read,groups:read,im:read,mpim:read')
  const state = Math.random().toString(36).slice(2)
  const url = `https://slack.com/oauth/v2/authorize?client_id=${encodeURIComponent(client_id)}&scope=${scopes}&redirect_uri=${encodeURIComponent(redirect)}&state=${state}`
  return url
}


